import React, { useState, useEffect } from "react";
import { useStateMachine } from "little-state-machine";
import updateAction from "./updateAction";

// import CustomTable from './table';
import ReactCustomTable from './reactTable';
import ReactTable from "react-table-6";
import ReactTooltip from "react-tooltip";
import "react-table-6/react-table.css";

import axios from 'axios';
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";

import { omit } from "lodash";



// Data Viz
import { ResponsiveBar } from '@nivo/bar';

// https://github.com/googleapis/google-auth-library-nodejs
// https://medium.com/google-cloud/securing-google-cloud-functions-using-service-account-and-how-to-access-it-in-service-service-582b4b5f210


var output2ChartdataR = [];
var output2ChartdataF = [];
var output2ChartdataM = [];

const Result = props => {
  const [ isLoading, setLoading ]  = useState(true);
  const { state, action } = useStateMachine(updateAction);
  const { push } = useHistory();

  const segmentTooltip = {
    'Champions': 'Bought recently, buy often and spend the most.',
    'Potential Loyalist': 'Recent customers with average frequency.',
    'New Customers': "Bought most recently, but not often. Promising: Recent shoppers, but haven’t spent much.",
    'Loyal Customers': "Buy on a regular basis. Responsive to promotions.",
    'Need Attention': "Above average recency, frequency and monetary values. May not have bought very recently though.", 
    'About To Sleep': "Below average recency and frequency. Will lose them if not reactivated.", 
    'Cant Lose Them': "Used to purchase frequently but haven’t returned for a long time.", 
    'At Risk': "Purchased often but a long time ago. Need to bring them back!", 
    'Hibernating': "Last purchase was long back and low number of orders. May be lost.",
    "Promising": "Recent shoppers, but haven't spent much."
  }


  const resetForm = data => {
    action({
      firstName: "",
      lastName: "",
      company: "",
      email: "",
      csvTable: [],
      csvTable_final: [],
      csvTableErrors: [],
      csvTableMeta: [],
      csvTableSelectedCol_Customer_ID: "",
      csvTableSelectedCol_Order_Date: "",
      csvTableSelectedCol_Order_ID: "",
      csvTableSelectedCol_Sales: "",
      csvTableSelectedCol_City: "",
      csvTableSelectedCol_Industry: "",
      csvTableSelectedCol_Email: "",
      userUploadShow: true,
      showTable: false,
      ShowTable_final: false,
    });
    setLoading(true);
    push("/");
  };

  const groupBy = function(data, key, valueKey) { 
    // https://gist.github.com/robmathers/1830ce09695f759bf2c4df15c29dd22d
    // `data` is an array of objects, `key` is the key (or property accessor) to group by
    // reduce runs this anonymous function on each element of `data` (the `item` parameter,
    // returning the `storage` parameter at the end
    return data.reduce(function(storage, item) {
      // // get the first instance of the key by which we're grouping
      var group = item[key];
      
      // // set `storage` for this instance of group to the outer scope (if not empty) or initialize it
      storage[group] = storage[group] || [];
      
      // // add this item to its group within `storage`
      // storage[group].Sales += item.Sales;

      // (storage[item.key])? storage[item.key] += item.valueKey : storage[item.key] = item.valueKey;
      
      // return the updated storage to the reduce function, which will then loop through the next 
      return storage; 
    }, {}); // {} is the initial value of the storage
  };

  const APIurl = 'https://aaarl-wed-demo-gateway-jo2f77bqia-nn.a.run.app/segment/';
  const SheetDBurl = 'https://sheetdb.io/api/v1/hshxmxozfnnd5';

  const keys = require('./aaarl-h2o-demo-invoker.json');
  const jwt = require('jsonwebtoken');

  async function generate_JWT() {
    const sa_email = 'aaarl-web-demo-invoker@aaarl-h2o-demo.iam.gserviceaccount.com';
    const audience = 'aaarl-wed-demo-gateway-jo2f77bqia-nn.a.run.app';

    const token = {
      iat: parseInt(Date.now() / 1000),
      exp: parseInt(Date.now() / 1000) + 3600,
      iss:  sa_email,
      aud: audience,
      sub: sa_email,
      email: sa_email,
    };
    
    const jwtSigned = jwt.sign( token, keys.private_key, {algorithm: 'RS256'} );
    return jwtSigned
  }

  function dynamicSort(property) {
    // https://stackoverflow.com/questions/1129216/sort-array-of-objects-by-string-property-value
      var sortOrder = 1;
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
      return function (a,b) {
          /* next line works with strings and numbers, 
          * and you may want to customize it to your needs
          */
          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
      }
  }

  async function predict_JWT() {
    
    const jwtSigned = await generate_JWT();
    const decoded_jwt = decodeURIComponent( escape( jwtSigned) );

    const headers = {
      'Authorization': `Bearer {${decoded_jwt}}`,
      'content-type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    ///////

    const axiosConfig = {
      headers
    };

    const data_toPredict = {
      "nlabel" : 5,
      "text_data" : JSON.stringify(state.yourDetails.csvTable.map(
        data => {
          return {
            Customer_ID: data[state.yourDetails.csvTableSelectedCol_Customer_ID.label],
            Order_Date: data[state.yourDetails.csvTableSelectedCol_Order_Date.label], //convert to ms 
            Order_ID: data[state.yourDetails.csvTableSelectedCol_Order_ID.label],
            Sales: data[state.yourDetails.csvTableSelectedCol_Sales.label],
            City: data[state.yourDetails.csvTableSelectedCol_City.label],
            Industry: data[state.yourDetails.csvTableSelectedCol_Industry.label],
            Email: data[state.yourDetails.csvTableSelectedCol_Email.label],
          }
        }
      ))
    };
    // console.log(data_toPredict);

    axios.put(
      APIurl,
      data_toPredict,
      axiosConfig
    )
    .then(res => {
      let csvTable_final_temp1 = JSON.parse(res.data['output1']);
      state.yourDetails.csvTable_final1 = csvTable_final_temp1;      

      let csvTable_final_temp2 = JSON.parse(res.data['output2']);
      state.yourDetails.csvTable_final2 = csvTable_final_temp2;
      // console.log(groupBy(state.yourDetails.csvTable_final2, 'Customer Group', 'Sales'));   

      // console.log(state.yourDetails.csvTable_final2);



      var totals2R = state.yourDetails.csvTable_final2.reduce(function (r, o) {
        if (!r[o['Customer Group']]) {
          r[o['Customer Group']] = { 'Customer Group': o['Customer Group'], Recency: 0 };
          output2ChartdataR.push(r[o['Customer Group']])
        }
        r[o['Customer Group']].Recency += o.Recency;
        r[o['Customer Group']].CountR = +r[o['Customer Group']].CountR ? r[o['Customer Group']].CountR + 1 : 1;
        return r;
          return r;
        }, {});
      //   console.log('totals2R and output2ChartdataR');
      
      // console.log('totals2R');
      // console.log(totals2R);
      // console.log('output2ChartdataR');
      // console.log(output2ChartdataR);

      output2ChartdataR = Object.keys(output2ChartdataR).map(function(k){
        const item  = output2ChartdataR[k];
        return {
            'Customer Group': item['Customer Group'],
            'Recency': Math.round(item.Recency/item.CountR),
          }
      })
      // console.log('output2ChartdataR 2');
      // console.log(output2ChartdataR);

      var totals2F = state.yourDetails.csvTable_final2.reduce(function (r, o) {
        if (!r[o['Customer Group']]) {
          r[o['Customer Group']] = { 'Customer Group': o['Customer Group'], Frequency: 0 };
          output2ChartdataF.push(r[o['Customer Group']])
        }
        r[o['Customer Group']].Frequency += o.Frequency;
        r[o['Customer Group']].CountF = +r[o['Customer Group']].CountF ? r[o['Customer Group']].CountF + 1 : 1;
        return r;
          return r;
        }, {});

      output2ChartdataF = Object.keys(output2ChartdataF).map(function(k){
      const item  = output2ChartdataF[k];
      return {
          'Customer Group': item['Customer Group'],
          'Frequency': Math.round(item.Frequency/item.CountF),
        }
      })

      var totals2M = state.yourDetails.csvTable_final2.reduce(function (r, o) {
        if (!r[o['Customer Group']]) {
          r[o['Customer Group']] = { 'Customer Group': o['Customer Group'], Monetary: 0 };
          output2ChartdataM.push(r[o['Customer Group']])
        }
        r[o['Customer Group']].Monetary += o.Monetary;
        return r;
          return r;
        }, {});
  
  

      let csvTable_final_temp3 = JSON.parse(res.data['output3']);
      state.yourDetails.csvTable_final3 = csvTable_final_temp3;   

      action({
        csvTable_final1: csvTable_final_temp1,
        csvTable_final2: csvTable_final_temp2,
        csvTable_final3: csvTable_final_temp3,
        ShowTable_final: true,
      });

      setLoading(false);
    })
    .catch(err => {
      console.log(err)
      setLoading(true);
      state.yourDetails.ShowTable_final = false;
      action({
        ShowTable_final: false,
      });
    });

  }



  useEffect(() => {
    axios.post(SheetDBurl,
    { sheet: 'Sheet1', data: {
      "Timestamp":new Date(),
      "First Name":state.yourDetails.firstName,
      "Last Name":state.yourDetails.lastName,
      "Company":state.yourDetails.company,
      "Business Email Address":state.yourDetails.email,
      "csvTableMeta": state.yourDetails.csvTableMeta,
      "csvTableErrors": state.yourDetails.csvTableErrors
    }}).then(function(result){
      // console.log(result);
    }, function(error){
      console.log(error);
    });

    predict_JWT();


  }, [])

  if (isLoading) {
    return (
      <>
        <h1>loading</h1>
        <p>Result may take longer on Demo site</p>
        {/* <button type="clear" onClick={updatePrediction}> Update Prediction</button> */}
      </>
    )
  }

  return (
    <>
      <h2>Result</h2>

      <h3>Output 1: RFM score analysis based segmentation</h3>
      <span className="subtitle">
        <span className="" style={{ }}>Description: </span>RFM stands for Recency, Frequency and Monetary customer behaviors. The score is derived using a simple statistical method and is scaled 1-5 for each behavior. The scores are then used to group customers into segments from high to low value.<br></br>
        <br></br>
      </span>

      <div className="container">
        {/* <button type="clear" onClick={updatePrediction}> Update Prediction</button> */}
        {/* <h2>Result</h2> */}
        {/* <h3>Final Table</h3> */}
        {state.yourDetails.ShowTable_final && (
          <div>
            <ReactTooltip place="left" type="success" effect="solid" />
            <ReactTable
              data={state.yourDetails.csvTable_final1}
              columns={[
                {
                  Header: "Segment",
                  accessor: "Segment",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span data-tip={segmentTooltip[row.value]}>{row.value}</span>;
                  }
                },
                {
                  Header: "Customer Count",
                  accessor: "Customer_Count",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "Recency",
                  accessor: "Recency",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "Frequency",
                  accessor: "Frequency",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "Monetary",
                  accessor: "Monetary",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "R",
                  accessor: "R",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "F",
                  accessor: "F",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "M",
                  accessor: "M",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "RFM Score",
                  accessor: "RFMScore",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
                {
                  Header: "Sales Percentage",
                  accessor: "Sales_Percentage",
                  Cell: (row) => {
                    /* Add data-tip */
                    return <span >{row.value}</span>;
                  }
                },
              ]}
              defaultPageSize={10}
              onPageSizeChange={() => {
                ReactTooltip.rebuild();
              }}
              className="-striped -highlight"
            />
            <div className="chart-area" style={{ height: "400px" }}>
              <ResponsiveBar 
                theme={{
                  labels: { text: { fontSize: 14 } },
                  legend: {
                    text: {
                      fontSize: 14
                    }
                  },
                  axis: {
                    ticks: {
                      text: {
                        fontSize: 18,
                        // fill: "lightblue"
                      }
                    }
                  }
                }}
                data={state.yourDetails.csvTable_final1.sort(dynamicSort("Customer_Count"))}
                keys={["Customer_Count"]}
                indexBy='Segment'
                colorBy='indexValue'
                // colors={{ scheme: 'yellow_green' }}
                layout="horizontal"
                margin={{ top: 50, right: 100, bottom: 50, left: 200 }}
                enableGridY={false}
                enableGridX={false}
                axisTop={null}
                axisBottom={{
                  tickSize: 0,
                  tickPadding: 5,
                  tickRotation: 0,
                  tickValues: 4,
                  legend: 'Customer Count',
                  legendPosition: 'middle',
                  legendOffset: 32
                }}
                axisRight={null}
                tooltip={({ id, value, color }) => (
                  <div
                      style={{
                          padding: 12,
                          color,
                          background: '#222222',
                      }}
                  >
                      {/* <span>Look, I'm custom :)</span> */}
                      {/* <br /> */}
                      <strong>
                          {/* {id}: {value} */}
                          Customer Count: {value}
                      </strong>
                  </div>
                )}
              />
            </div>
          </div>
        )}
      </div>
      <button type="submit">       <CSVLink 
        data={state.yourDetails.csvTable_final1}
        filename={"AAARL-demo.csv"}
        className="btn"
      >
        Download Result
      </CSVLink></button>
      <br></br>

      <h3>Output 2: cluster analysis based segmentation </h3>
      <span className="subtitle">
        <span className="" style={{ }}>Description: </span>Cluster analysis allows us to take advantage of many features that may otherwise be a limitation when conducting typical segmentation analysis. It delivers insights using pattern recognition with more targeted complex relationships such as addition of features like city and/or industry as shown in this data.<br></br>
        <br></br>
      </span>

      <div className="container">
        {/* <button type="clear" onClick={updatePrediction}> Update Prediction</button> */}
        {/* <h2>Result</h2> */}
        {/* <h3>Final Table</h3> */}
        {state.yourDetails.ShowTable_final && (
          <>
            <ReactCustomTable data={state.yourDetails.csvTable_final2}/>
            {/* <ReactCustomTable data={ omit(state.yourDetails.csvTable_final2, ['Sales'])}/> */}
            {/* <ReactCustomTable data={ (({ Sales, ...other }) => other)(state.yourDetails.csvTable_final2) }/> */}
          </>
        )}
      </div>
      <div className="chart-area" style={{ height: "400px" }}>
        <ResponsiveBar 
          theme={{
            labels: { text: { fontSize: 14 } },
            legend: {
              text: {
                fontSize: 14
              }
            },
            axis: {
              ticks: {
                text: {
                  fontSize: 18,
                  // fill: "lightblue"
                }
              }
            }
          }}
          data={
            output2ChartdataR.sort(dynamicSort("Customer Group"))
          }
          keys={["Recency"]}
          indexBy='Customer Group'
          colorBy='indexValue'
          layout="vertical"
          margin={{ top: 50, right: 100, bottom: 50, left: 200 }}
          enableGridY={false}
          enableGridX={false}
          axisTop={null}
          axisBottom={{
            tickSize: 0,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: 4,
            legend: 'Customer Group',
            legendPosition: 'middle',
            legendOffset: 32
        }}
          axisRight={null}
          axisLeft={{
            legend: 'Avg Recency',
            legendPosition: 'middle',
            legendOffset: -72,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
          }}
        />
      </div>
      <div className="chart-area" style={{ height: "400px" }}>
        <ResponsiveBar 
          theme={{
            labels: { text: { fontSize: 14 } },
            legend: {
              text: {
                fontSize: 14
              }
            },
            axis: {
              ticks: {
                text: {
                  fontSize: 18,
                  // fill: "lightblue"
                }
              }
            }
          }}
          data={
            output2ChartdataF.sort(dynamicSort("Customer Group"))
          }
          keys={["Frequency"]}
          indexBy='Customer Group'
          colorBy='indexValue'
          layout="vertical"
          margin={{ top: 50, right: 100, bottom: 50, left: 200 }}
          enableGridY={false}
          enableGridX={false}
          axisTop={null}
          axisBottom={{
            tickSize: 0,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: 4,
            legend: 'Customer Group',
            legendPosition: 'middle',
            legendOffset: 32
        }}
          axisRight={null}
          axisLeft={{
            legend: 'Avg Frequency',
            legendPosition: 'middle',
            legendOffset: -72,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
          }}
        />
      </div>
      <div className="chart-area" style={{ height: "400px" }}>
        <ResponsiveBar 
          theme={{
            labels: { text: { fontSize: 14 } },
            legend: {
              text: {
                fontSize: 14
              }
            },
            axis: {
              ticks: {
                text: {
                  fontSize: 18,
                  // fill: "lightblue"
                }
              }
            }
          }}
          data={
            output2ChartdataM.sort(dynamicSort("Customer Group"))
          }
          keys={["Monetary"]}
          indexBy='Customer Group'
          colorBy='indexValue'
          layout="vertical"
          margin={{ top: 50, right: 100, bottom: 50, left: 200 }}
          enableGridY={false}
          enableGridX={false}
          axisTop={null}
          axisBottom={{
            tickSize: 0,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: 4,
            legend: 'Customer Group',
            legendPosition: 'middle',
            legendOffset: 32
        }}
          axisRight={null}
          axisLeft={{
            legend: 'Sum of Monetary',
            legendPosition: 'middle',
            legendOffset: -72,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
          }}
        />
      </div>
      <button type="submit">       <CSVLink 
        data={state.yourDetails.csvTable_final2}
        filename={"AAARL-demo.csv"}
        className="btn"
      >
        Download Result
      </CSVLink></button>

      {/* <h3>Output 3</h3>
      <button type="submit">       <CSVLink 
        data={state.yourDetails.csvTable_final3}
        filename={"AAARL-demo.csv"}
        className="btn"
      >
        Download Result
      </CSVLink></button>

      <div className="container">
        {state.yourDetails.ShowTable_final && (
          <Table data={state.yourDetails.csvTable_final3}/>
        )}
        <button type="clear" onClick={resetForm}> Reset Form</button>
      </div> */}

    </>
  );
};

export default Result;
